import { $uniUP } from "../.."

export class SidebarTooltipController implements ng.IComponentController {
  private $anchor: JQLite
  private title: string

  constructor(
    $element: JQLite,
    private $timeout: ng.ITimeoutService,
    private $window: ng.IWindowService,
    private $log: ng.ILogService
  ) {
    this.$anchor = $element.find("a")
  }

  $onInit() {
    this.$log.info("Instanciando sidebar tooltip", this.title)

    let title =
      this.title || this.$anchor.attr("title") || this.$anchor.attr("titleDev")

    if (!title) return
    ;(this.$window as any).tippy(this.$anchor[0], {
      content: title,
      allowHTML: true,
      arrow: true,
      trigger: "mouseenter",
      theme: "unimat",
      placement: "right",
      popperOptions: {
        modifiers: {
          preventOverflow: {
            boundariesElement: "window"
          }
        }
      }
    })
  }
}
/**
 * Panel lateral de acceso rápido a los tipos de catálogo
 */
$uniUP.component("sidebarTooltip", {
  bindings: {
    title: "@"
  },
  controller: SidebarTooltipController
  // transclude: true,
  // template : "<ng-transclude></ng-transclude>"
})
